import { CSSProperties, FC } from "react";
import { FormControl, InputGroup } from "react-bootstrap-v5";
import { invalidChar } from "app/utilities/invalidChar";
import { FormikProps } from "formik";

import './styles/style.css';
import { PatternFormat } from "react-number-format";

type Props = {
    formFormik: FormikProps<any>,
    label: string,
    htmlFor: string,
    name: string,
    placeholder?: string,
    units?: string,
    hasUnits?: boolean,
    styleBootstrapClasses?: string
    width?: string,
    onkeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void,
    validation?: string | undefined,
    type?: string,
    isPhoneFormat?: boolean,
    tabIndex?: number,
    disabled?: boolean,
    defaultValue?: string | number,
}

const InputModalText: FC<Props> = ({ validation, defaultValue, disabled = false, tabIndex, type = "text", isPhoneFormat = true, formFormik, label, htmlFor, name, placeholder, units, styleBootstrapClasses = '', width = "50", onkeyDown, hasUnits = false }) => {
    return (
        <div className={`w-${width} ${styleBootstrapClasses} container__modal--input`}>
            <label htmlFor={htmlFor} className="form-label">
                {label}
            </label>
            <InputGroup>
                {isPhoneFormat ? (
                    <>
                        <FormControl
                            style={{ borderRadius: '5px' }}
                            type={type}
                            id={htmlFor}
                            tabIndex={tabIndex}
                            placeholder={placeholder}
                            required
                            isInvalid={!!(formFormik.errors[name] && formFormik.touched[name])}
                            onKeyDown={onkeyDown}
                            {...formFormik.getFieldProps(name)}
                            disabled={disabled}
                            value={formFormik.values[name]}
                            onChange={formFormik.handleChange}
                        />
                        {hasUnits && (
                            <InputGroup.Text>{units}</InputGroup.Text>
                        )}
                        <FormControl.Feedback type="invalid">
                            {formFormik.errors[name]}
                        </FormControl.Feedback>
                    </>
                ) : (
                    <>
                        <PatternFormat
                            style={{ borderRadius: '5px' }}
                            format="## #### ####"
                            mask="_"
                            tabIndex={tabIndex}
                            allowEmptyFormatting={true}
                            placeholder={placeholder}
                            onKeyDown={onkeyDown}
                            {...formFormik.getFieldProps(name)}
                        />
                        {formFormik.touched[name] &&
                            formFormik.errors[name] && (
                                <div className="fv-plugins-message-container text-danger w-100">
                                    <span role="alert">
                                        {formFormik.errors[name]}
                                    </span>
                                </div>
                            )}
                    </>
                )}

            </InputGroup>
        </div>
    )
}

export { InputModalText }